import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon, MailIcon, PhoneIcon, CheckIcon } from 'lucide-react';
import { business, images } from '../data/business';
import { services, sectors } from '../data/services';
import { ContactBand } from '../components/ContactBand';
import { useSeo } from '../utils/seo';
export function Home() {
  useSeo({
    title: 'Gordijnrails van Goelst International B.V. | Amersfoort',
    description: 'Goelst International in Amersfoort ontwikkelt en produceert gordijnrailsystemen: handbediende, elektrische en gemotoriseerde gordijnrails voor projecten in zorg, hospitality en architectuur.',
    path: '/'
  });
  return <>
      <section className="border-b border-line bg-white" data-id="element-283" data-mp="2dhgs344n5yam">
        <div className="mx-auto grid max-w-shell gap-12 px-6 py-14 md:py-20 lg:grid-cols-[1.05fr_1fr] lg:items-center lg:gap-16" data-id="element-284" data-mp="2dj1lgqf7zb6w">
          <div data-id="element-285" data-mp="3owvljxxn680z">
            <p className="text-[13px] font-semibold uppercase tracking-[0.2em] text-accent" data-id="element-286" data-mp="3owcfpfl9na3b">
              Gordijnrailsystemen sinds {business.since}
            </p>
            <h1 className="mt-6 font-display text-4xl font-700 leading-[1.03] tracking-tightest text-ink md:text-[60px]" data-id="element-287" data-mp="30uoypvb5y2aa">
              Gordijnrails die het interieur afmaken in plaats van onderbreken
            </h1>
            <p className="mt-7 max-w-xl text-[18px] leading-relaxed text-ink-soft" data-id="element-288" data-mp="2mx0dunh3iv58">
              Goelst International B.V. ontwikkelt en produceert hoogwaardige gordijnrailsystemen voor architecten,
              interieurontwerpers en professionele projecten. Van handbediende rails tot volledig gemotoriseerde
              systemen, uitgewerkt op maat en geleverd vanuit Amersfoort aan opdrachtgevers in Nederland en
              wereldwijd.
            </p>
            <div className="mt-9 flex flex-col gap-3 sm:flex-row" data-id="element-289" data-mp="23auef583awe5">
              <a href={`mailto:${business.email}?subject=Aanvraag%20gordijnrails`} className="inline-flex items-center justify-center gap-2 bg-accent px-7 py-4 text-[15px] font-semibold text-white transition-colors hover:bg-accent-dark" data-id="element-290" data-mp="1z6e852ukdmye">
                <MailIcon className="h-4 w-4" aria-hidden="true" data-id="element-291" data-mp="1omu3che5i763" />
                Vraag advies aan
              </a>
              <Link to="/diensten" className="inline-flex items-center justify-center gap-2 border border-ink px-7 py-4 text-[15px] font-semibold text-ink transition-colors hover:bg-ink hover:text-white" data-id="element-292" data-mp="1ankvq640gldq">
                Bekijk onze gordijnrailsystemen
                <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-293" data-mp="2899y82qz15a9" />
              </Link>
            </div>
            <dl className="mt-12 grid gap-6 border-t border-line pt-8 sm:grid-cols-3" data-id="element-294" data-mp="1tklzxopqqhgm">
              <div data-id="element-295" data-mp="1yjgn12uqqs6j">
                <dt className="text-[13px] uppercase tracking-[0.14em] text-ink-mute" data-id="element-296" data-mp="1yinlqhejwuvs">Vestiging</dt>
                <dd className="mt-2 font-display text-[17px] font-600 text-ink" data-id="element-297" data-mp="2m8rokmjx0qlq">Amersfoort, Utrecht</dd>
              </div>
              <div data-id="element-298" data-mp="2r2m7hnrp51jr">
                <dt className="text-[13px] uppercase tracking-[0.14em] text-ink-mute" data-id="element-299" data-mp="flkc9gnmhzcn">Actief sinds</dt>
                <dd className="mt-2 font-display text-[17px] font-600 text-ink" data-id="element-300" data-mp="an91n3pi7ktd">{business.since}</dd>
              </div>
              <div data-id="element-301" data-mp="od2oxhld1x0z">
                <dt className="text-[13px] uppercase tracking-[0.14em] text-ink-mute" data-id="element-302" data-mp="odmad8a7z3jr">Specialisme</dt>
                <dd className="mt-2 font-display text-[17px] font-600 text-ink" data-id="element-303" data-mp="kd2c21dwttw1">Gordijnrails op maat</dd>
              </div>
            </dl>
          </div>

          <figure className="relative" data-id="element-304" data-mp="3ntsl6p4sgn1y">
            <img src={images.interiorTallWindow} alt="Interieur met hoge raampartij en witte vitrage die vanaf het plafond valt" className="h-[420px] w-full object-cover md:h-[560px]" width={1200} height={1200} data-id="element-305" data-mp="3nutzd2h3ppnw" />
            <figcaption className="mt-3 text-[13px] text-ink-mute" data-id="element-306" data-mp="1h18ag6k8nq1v">
              Sfeerbeeld van een interieur met plafondgemonteerde gordijnrails. Illustratief beeld, geen specifiek
              project.
            </figcaption>
          </figure>
        </div>
      </section>

      <section className="border-b border-line bg-canvas" aria-labelledby="wie-wij-zijn" data-id="element-307" data-mp="2ce12ghwbmdpo">
        <div className="mx-auto max-w-shell px-6 py-16 md:py-24" data-id="element-308" data-mp="2hbt4w5uldi84">
          <div className="grid gap-12 lg:grid-cols-[0.85fr_1.15fr] lg:gap-20" data-id="element-309" data-mp="2mb5rcphjwna6">
            <div data-id="element-310" data-mp="2m92qtbirvbr7">
              <h2 id="wie-wij-zijn" className="font-display text-3xl font-700 leading-[1.1] tracking-tightest text-ink md:text-[40px]" data-id="element-311" data-mp="2qcr0q0uvmjfm">
                Wie Goelst International is
              </h2>
              <p className="mt-5 text-[15px] leading-relaxed text-ink-mute" data-id="element-312" data-mp="303lqhf7c015t">
                Een technisch bedrijf met een esthetische opdracht: een rail die werkt en die je niet ziet.
              </p>
            </div>
            <div className="space-y-5 text-[17px] leading-relaxed text-ink-soft" data-id="element-313" data-mp="3a2kycvk9vsrr">
              <p data-id="element-314" data-mp="3e34wa1co70ey">
                Goelst International B.V. is gevestigd aan de Modemweg 19 in Amersfoort en richt zich volledig op één
                onderdeel van het interieur: het gordijnrailsysteem. Het assortiment omvat handbediende en
                elektrische gordijnrails, systemen voor zorginstellingen, commerciële toepassingen en volledig op
                maat gemaakte oplossingen.
              </p>
              <p data-id="element-315" data-mp="oh1ntekylkpe">
                Sinds {business.since} combineren wij technische precisie met esthetische integratie. Dat betekent in
                de praktijk dat wij tijdens het ontwerp meedenken over plafonddetails, sparingen, baanlengtes en
                bediening — en niet pas aan het einde van een project een rail leveren die er ergens tussen moet
                passen. Onze klanten zijn architecten, interieurontwerpers, aannemers en projectpartners die werken
                in hospitality, healthcare, architectuur en high-end residential.
              </p>
              <p data-id="element-316" data-mp="201yp43067apl">
                Het complete productoverzicht, de technische documentatie en de internationale informatie vindt u op
                de officiële website van{' '}
                <a href={business.website} target="_blank" rel="noopener" className="font-semibold text-ink underline decoration-accent underline-offset-4" data-id="element-317" data-mp="271nsgmlksyt">
                  gordijnrails specialist Goelst International in Amersfoort
                </a>
                . Deze pagina geeft een beknopt lokaal profiel van ons bedrijf, onze toepassingsgebieden en onze
                contactmogelijkheden.
              </p>
              <p data-id="element-318" data-mp="31mykb75hhtr5">
                <Link to="/over-ons" className="inline-flex items-center gap-2 font-semibold text-accent transition-colors hover:text-accent-dark" data-id="element-319" data-mp="31nhshw5c13rz">
                  Lees meer over onze werkwijze en achtergrond
                  <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-320" data-mp="14twqsx9gm4ff" />
                </Link>
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="border-b border-line bg-white" aria-labelledby="oplossingen" data-id="element-321" data-mp="19ygydf77l7xv">
        <div className="mx-auto max-w-shell px-6 py-16 md:py-24" data-id="element-322" data-mp="19wnv89vt15um">
          <div className="flex flex-col gap-6 border-b border-line pb-10 md:flex-row md:items-end md:justify-between" data-id="element-323" data-mp="1nrge9iawl45y">
            <div data-id="element-324" data-mp="1ix2ivfw8qx1a">
              <h2 id="oplossingen" className="max-w-2xl font-display text-3xl font-700 leading-[1.1] tracking-tightest text-ink md:text-[40px]" data-id="element-325" data-mp="1xo328fyj0bc7">
                Onze belangrijkste gordijnrailoplossingen
              </h2>
              <p className="mt-4 max-w-2xl text-[17px] leading-relaxed text-ink-soft" data-id="element-326" data-mp="26nycmik9c2b6">
                Zes lijnen die samen het grootste deel van elke projectvraag dekken — van een enkele handbediende
                baan tot een gemotoriseerd systeem dat meebeweegt met het gebouw.
              </p>
            </div>
            <Link to="/diensten" className="inline-flex shrink-0 items-center gap-2 text-[15px] font-semibold text-ink underline decoration-accent underline-offset-4" data-id="element-327" data-mp="8bhnnkxbxqtg">
              Alle gordijnrails bekijken
              <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-328" data-mp="16kxtu4gww3wh" />
            </Link>
          </div>

          <ul className="divide-y divide-line" data-id="element-329" data-mp="1ak6l92ohbpov">
            {services.map(service => <li key={service.id} data-id="element-330" data-mp="dw8v2c3bwanw">
                <Link to={`/diensten#${service.id}`} className="group grid gap-3 py-7 md:grid-cols-[72px_1fr_auto] md:items-start md:gap-8" data-id="element-331" data-mp="dxaccyaxtte2">
                  <span className="font-display text-[15px] font-600 text-accent" data-id="element-332" data-mp="my01xk9lunjc">{service.index}</span>
                  <div data-id="element-333" data-mp="rsvviouhpiyk">
                    <h3 className="font-display text-[22px] font-600 leading-snug text-ink transition-colors group-hover:text-accent" data-id="element-334" data-mp="1ybavs8bqokf8">
                      {service.title}
                    </h3>
                    <p className="mt-2 max-w-3xl text-[16px] leading-relaxed text-ink-soft" data-id="element-335" data-mp="2ddsupmmna0ui">{service.summary}</p>
                  </div>
                  <ArrowRightIcon className="h-5 w-5 shrink-0 text-ink-mute transition-transform group-hover:translate-x-1 group-hover:text-accent md:mt-2" aria-hidden="true" data-id="element-336" data-mp="28g0u847xp6ep" />
                </Link>
              </li>)}
          </ul>
        </div>
      </section>

      <section className="border-b border-line bg-ink text-white" aria-labelledby="toepassingen" data-id="element-337" data-mp="1ulhuk0jdkh03">
        <div className="mx-auto max-w-shell px-6 py-16 md:py-24" data-id="element-338" data-mp="1pqko91dhclqw">
          <div className="grid gap-12 lg:grid-cols-[1fr_1fr] lg:gap-16" data-id="element-339" data-mp="1kq6f1g0575ra">
            <div data-id="element-340" data-mp="1gobe4cm4iue1">
              <h2 id="toepassingen" className="font-display text-3xl font-700 leading-[1.1] tracking-tightest md:text-[40px]" data-id="element-341" data-mp="1goux7wnifotn">
                Toepassingen waarin onze rails hun werk doen
              </h2>
              <p className="mt-5 max-w-xl text-[17px] leading-relaxed text-white/75" data-id="element-342" data-mp="col7yktz3dgv">
                Elke sector stelt andere eisen. In een hotelkamer telt de herhaalbaarheid van het detail, in een
                ziekenhuis de dagelijkse belasting en de reiniging, in een woonhuis de stilte van de motor. Wij
                vertalen die eisen naar een railconfiguratie die past.
              </p>
              <div className="mt-8 space-y-6" data-id="element-343" data-mp="3q3hilp2qxar4">
                {sectors.map(sector => <div key={sector.title} className="border-t border-white/15 pt-6" data-id="element-344" data-mp="3q152lhgjtagp">
                    <h3 className="font-display text-[19px] font-600" data-id="element-345" data-mp="3l2bphq56blh2">{sector.title}</h3>
                    <p className="mt-2 max-w-xl text-[16px] leading-relaxed text-white/70" data-id="element-346" data-mp="3p7vrkegsasg">{sector.text}</p>
                  </div>)}
              </div>
            </div>
            <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-1" data-id="element-347" data-mp="37boyyl9kh1w2">
              <figure data-id="element-348" data-mp="32eov8h06wb84">
                <img src={images.interiorBeige} alt="Woonruimte met beige overgordijnen over de volledige hoogte van twee raampartijen" className="h-64 w-full object-cover lg:h-80" width={1200} height={1200} data-id="element-349" data-mp="32d41gtlp8wbb" />
                <figcaption className="mt-2 text-[13px] text-white/50" data-id="element-350" data-mp="18x127umnrul6">
                  High-end residential — illustratief sfeerbeeld.
                </figcaption>
              </figure>
              <figure data-id="element-351" data-mp="20mvrxsefhmad">
                <img src={images.interiorSeaView} alt="Lichte hospitality-ruimte met witte vitrage en rode overgordijnen" className="h-64 w-full object-cover lg:h-80" width={1200} height={1200} data-id="element-352" data-mp="20k9n40ix9kvu" />
                <figcaption className="mt-2 text-[13px] text-white/50" data-id="element-353" data-mp="1wmlmcgujsxw1">
                  Hospitality — illustratief sfeerbeeld.
                </figcaption>
              </figure>
            </div>
          </div>
        </div>
      </section>

      <section className="border-b border-line bg-white" aria-labelledby="werkwijze" data-id="element-354" data-mp="2mv15h7lvedur">
        <div className="mx-auto max-w-shell px-6 py-16 md:py-24" data-id="element-355" data-mp="2hv6fd69x5sar">
          <h2 id="werkwijze" className="max-w-3xl font-display text-3xl font-700 leading-[1.1] tracking-tightest text-ink md:text-[40px]" data-id="element-356" data-mp="2hxrhlwe4qa91">
            Van tekening naar een rail die past
          </h2>
          <p className="mt-4 max-w-2xl text-[17px] leading-relaxed text-ink-soft" data-id="element-357" data-mp="244t9d9gl8no2">
            Bij projectmatig werk zit het risico zelden in de rail zelf, maar in de afstemming eromheen. Daarom
            volgen wij een vaste route van vraag naar levering.
          </p>

          <ol className="mt-12 grid gap-10 md:grid-cols-2 lg:grid-cols-4" data-id="element-358" data-mp="1q4ig5zrt2wzq">
            {[{
            step: '01',
            title: 'Vraag en uitgangspunten',
            text: 'We inventariseren de raampartijen, stofkeuze, montagesituatie en gewenste bediening. Op basis daarvan bepalen we welk systeem in aanmerking komt.'
          }, {
            step: '02',
            title: 'Technische uitwerking',
            text: 'Maatvoering, bochten, sparingen en aandrijving worden vastgelegd op tekening, inclusief de voorbereiding die de installateur nodig heeft.'
          }, {
            step: '03',
            title: 'Productie op maat',
            text: 'Profielen worden op lengte gemaakt en waar nodig gebogen, zodat het systeem op de bouw alleen nog gemonteerd hoeft te worden.'
          }, {
            step: '04',
            title: 'Levering en fasering',
            text: 'Bij grotere projecten leveren we per bouwdeel, verdieping of kamerreeks, afgestemd op de planning van de aannemer.'
          }].map(item => <li key={item.step} className="flex flex-col border-t-2 border-ink pt-5" data-id="element-359" data-mp="27tuapu8bo774">
                <span className="font-display text-[13px] font-600 uppercase tracking-[0.16em] text-accent" data-id="element-360" data-mp="2cozxswdgnrws">
                  Stap {item.step}
                </span>
                <h3 className="mt-3 font-display text-[20px] font-600 leading-snug text-ink" data-id="element-361" data-mp="26bm9ulq3qyfe">{item.title}</h3>
                <p className="mt-3 text-[16px] leading-relaxed text-ink-soft" data-id="element-362" data-mp="2kb55if1q8hat">{item.text}</p>
              </li>)}
          </ol>
        </div>
      </section>

      <section className="border-b border-line bg-canvas" aria-labelledby="waarom" data-id="element-363" data-mp="2u800wp2pe1kv">
        <div className="mx-auto max-w-shell px-6 py-16 md:py-24" data-id="element-364" data-mp="2p9ghavbl11vo">
          <div className="grid gap-12 lg:grid-cols-[1fr_1.1fr] lg:items-center lg:gap-16" data-id="element-365" data-mp="2p96oz132eimt">
            <figure data-id="element-366" data-mp="33xt9dh7ju0kw">
              <img src={images.railProfile} alt="Wit aluminium gordijnrailprofiel met glijders in close-up" className="w-full bg-white object-contain p-8" width={1000} height={1000} data-id="element-367" data-mp="3405svysygj02" />
              <figcaption className="mt-2 text-[13px] text-ink-mute" data-id="element-368" data-mp="381rce2zzvvj8">
                Productbeeld van een aluminium railprofiel met glijders.
              </figcaption>
            </figure>
            <div data-id="element-369" data-mp="ewx07rjq54p">
              <h2 id="waarom" className="font-display text-3xl font-700 leading-[1.1] tracking-tightest text-ink md:text-[40px]" data-id="element-370" data-mp="dcczc2uy4l3">
                Waarop opdrachtgevers ons beoordelen
              </h2>
              <p className="mt-5 text-[17px] leading-relaxed text-ink-soft" data-id="element-371" data-mp="38uyq0de38jwf">
                Een gordijnrail wordt pas interessant op het moment dat er iets niet klopt: een baan die te zwaar
                loopt, een motor die te veel geluid maakt, een sparing die niet past. Onze aandacht gaat naar precies
                die punten.
              </p>
              <ul className="mt-8 space-y-4" data-id="element-372" data-mp="33u2kxwi02rpf">
                {['Eén specialisme: gordijnrailsystemen, geen breed assortiment eromheen.', 'Aluminium gordijnrails op maat afgekort en waar nodig gebogen.', 'Handbediende, elektrische en gemotoriseerde uitvoeringen binnen één productfamilie.', 'Uitwerking van plafond- en inbouwdetails in overleg met architect en installateur.', 'Ervaring met projecten in de zorg, hospitality en commercieel vastgoed.', 'Levering vanuit Amersfoort, zowel binnen Nederland als internationaal.'].map(item => <li key={item} className="flex gap-3 text-[16px] leading-relaxed text-ink-soft" data-id="element-373" data-mp="1jdl1ez8palm8">
                    <CheckIcon className="mt-1 h-4 w-4 shrink-0 text-accent" aria-hidden="true" data-id="element-374" data-mp="1efjkajuu4wde" />
                    <span data-id="element-375" data-mp="1abvarvmn7qpi">{item}</span>
                  </li>)}
              </ul>
              <div className="mt-9 flex flex-col gap-3 sm:flex-row" data-id="element-376" data-mp="15dk41trn9wbi">
                <a href={`tel:${business.phoneLink}`} className="inline-flex items-center justify-center gap-2 bg-ink px-6 py-4 text-[15px] font-semibold text-white transition-colors hover:bg-accent" data-id="element-377" data-mp="3v3xgjbb30x7e">
                  <PhoneIcon className="h-4 w-4" aria-hidden="true" data-id="element-378" data-mp="25kffurxn6tlu" />
                  {business.phoneDisplay}
                </a>
                <Link to="/resources" className="inline-flex items-center justify-center gap-2 border border-ink px-6 py-4 text-[15px] font-semibold text-ink transition-colors hover:bg-ink hover:text-white" data-id="element-379" data-mp="2enggwe7nhuin">
                  Bekijk onze resources
                  <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-380" data-mp="2tbl4nwlk8w8a" />
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      <ContactBand heading="Een project met gordijnrails op de planning?" text="Stuur ons de tekeningen of beschrijf de situatie in een paar regels. Wij denken mee over montagewijze, baanindeling en bediening, en komen terug met een voorstel dat bij uw project past." data-id="element-381" data-mp="2y9csaef69w6o" />
    </>;
}